import React from "react";
import "./Projects.css";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import transition from "../../transition";

import RevealHeading from "../shared/RevealHeading";
import projects from "../../data/projects";
import Seo from "../../seo/Seo";
import { breadcrumbJsonLd } from "../../seo/site";
import { useLang, useTranslations, langPath } from "../../i18n";
import { localizeProject } from "../../i18n/projectContent";

const ease = [0.83, 0, 0.17, 1];

const Projects = () => {
  const lang = useLang();
  const t = useTranslations();
  const items = projects.map((p) => localizeProject(p, lang));

  return (
    <motion.div className="Home page">
      <Seo
        lang={lang}
        path="/projects"
        title={t.seo.workTitle}
        description={t.seo.workDesc}
        jsonLd={breadcrumbJsonLd([
          { name: t.nav.index, path: `/${lang}` },
          { name: t.nav.work, path: `/${lang}/projects` },
        ])}
      />
      <div className="bg"></div>
      <h1 className="visually-hidden">
        {t.projects.title1} {t.projects.title2}
      </h1>

      <section className="page-hero">
        <div className="headers">
          <div className="header">
            <RevealHeading delay={-0.25}>{t.projects.title1}</RevealHeading>
            <RevealHeading delay={-0.1}>&nbsp;{t.projects.title2}</RevealHeading>
          </div>
        </div>
        <motion.div
          className="page-hero-meta"
          initial={{ opacity: 0, y: 40, transition: { duration: 1, ease } }}
          animate={{
            opacity: 1,
            y: 0,
            transition: { duration: 1.5, ease, delay: 0.6 },
          }}
        >
          <p>{t.projects.count.replace("{n}", projects.length)}</p>
        </motion.div>
      </section>

      <div className="projects-nav projects-nav-full">
        <div className="projects-nav-container">
          {items.map((project) => (
            <div className="project-item" key={project.slug}>
              <Link to={langPath(`/projects/${project.slug}`, lang)}>
                <div className="project-link">
                  <div className="project-l">
                    <div className="project-link-img">
                      <img
                        src={project.image}
                        alt={project.name}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <div className="project-name">
                      <h2>{project.name}</h2>
                    </div>
                  </div>
                  <div className="project-date">
                    <p>{project.category}</p>
                  </div>
                  <div className="project-dir">
                    <p>&#8599;</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="footer">
        <div className="divider"></div>
        <div className="footer-content">
          <div className="footer-col">
            <Link to={langPath("/contact", lang)}>
              <p>{t.projects.cta} &#8599;</p>
            </Link>
          </div>
          <div className="footer-col">
            <p>{t.projects.footerTitle}</p>
          </div>
          <div className="footer-col">
            <p>{t.projects.footerBased}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default transition(Projects);
